module.exports = __webpack_public_path__ + "static/media/IMG_4554.96ee97de.JPG";